export default "__VITE_ASSET__BhZSkznw__"